/**
 * Must run before any code that uses fetch (e.g. @react-pdf/renderer font loading).
 * Binding fetch to window avoids "Failed to execute 'fetch' on 'Window': Illegal invocation"
 * when the library calls fetch after it has been passed around or bundled.
 */
if (typeof window !== 'undefined' && typeof window.fetch === 'function') {
  window.fetch = window.fetch.bind(window);
}
